export function saveCart(state){
  return {
    type: 'SAVE_CART',
    payload: state
  }
}
export function saveCartContacts(contacts){
  return {
    type: 'SAVE_CART_CONTACTS',
    payload: contacts
  }
}